import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/esm/toConsumableArray';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _everyInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/every';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getGroups = function getGroups(state) {
  return state.searchString && state.searchString !== '' ? state.filteredGroups : state.groups;
};
var getCursorIndex = function getCursorIndex(state) {
  return state.cursorIndex;
};
var isIndexMatchCursor = function isIndexMatchCursor(state, index) {
  var cursorIndex = getCursorIndex(state);
  if (cursorIndex === null) return false;
  return index[0] === cursorIndex[0] && index[1] === cursorIndex[1];
};
var isEmpty = function isEmpty(state) {
  var groups = getGroups(state);
  return groups.length === 0 || _everyInstanceProperty(groups).call(groups, function (g) {
    return !g.options || g.options.length === 0;
  });
};
var withoutGroupsLabel = function withoutGroupsLabel(_ref) {
  var groups = _ref.groups;
  return _everyInstanceProperty(groups).call(groups, function (g) {
    return !g.label;
  });
};
var OptionGroupTypes = {
  HEADER: 'header',
  OPTION: 'option',
  DIVIDER: 'divider'
};
var getPlainOptionsFromGroups = function getPlainOptionsFromGroups(groups) {
  return _reduceInstanceProperty(groups).call(groups, // eslint-disable-next-line no-shadow
  function (acc, group, i, groups) {
    var _context, _context2, _context3;

    return _concatInstanceProperty(acc).call(acc, _filterInstanceProperty(_context = _concatInstanceProperty(_context2 = [optionsNotEmpty(group.options) && group.label && {
      type: OptionGroupTypes.HEADER,
      label: group.label
    }]).call(_context2, _toConsumableArray(_mapInstanceProperty(_context3 = group.options).call(_context3, function (option, j) {
      return _objectSpread(_objectSpread({}, option), {}, {
        index: [i, j],
        type: OptionGroupTypes.OPTION
      });
    })), [optionsNotEmpty(group.options) && i < groups.length - 1 && {
      type: OptionGroupTypes.DIVIDER
    }])).call(_context, function (e) {
      return e;
    }));
  }, []);
};
var getPlainOptions = function getPlainOptions(state) {
  return getPlainOptionsFromGroups(getGroups(state));
};

function optionsNotEmpty(options) {
  return options && options.length > 0;
}

function getOptionValue(option) {
  return typeof option.value === 'string' ? option.value : option.label;
}
var getSelectedValue = function getSelectedValue(state) {
  if (state.selected === null) {
    return null;
  }

  return getOptionValue(state.selected);
};
var getSelected = function getSelected(state) {
  return state.selected;
};
var getDefaultCursorIndex = function getDefaultCursorIndex(groups) {
  if (groups.length === 0) {
    return null;
  }

  var firstNonEmptyGroupIndex = _findIndexInstanceProperty(groups).call(groups, function (group) {
    return group.options && group.options.length > 0;
  });

  if (firstNonEmptyGroupIndex === -1) {
    return null;
  }

  return [firstNonEmptyGroupIndex, 0];
};

export { OptionGroupTypes, getCursorIndex, getDefaultCursorIndex, getGroups, getOptionValue, getPlainOptions, getPlainOptionsFromGroups, getSelected, getSelectedValue, isEmpty, isIndexMatchCursor, withoutGroupsLabel };
